import * as React from "react"
import { Typography } from "@mui/material"


export default function countMappedColumn() {
	return {
		name: 'countMapped', label: 'Count Mapped',
		options: {
			filter: false,
			customBodyRowRender: value => <Typography sx={{ textAlign: 'center' }}>{value}</Typography>
		}
	}
}